var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"declined-tenant",attrs:{"data-test":"declined-tenant"}},[_c('div',[_vm._v(_vm._s(_vm.declinedText))]),(_vm.membership.supervisionReason)?_c('div',{attrs:{"data-test":"declined-reason"}},[_vm._v(" "+_vm._s(_vm.$t("supervision.declined-tenant.reason", { reason: _vm.membership.supervisionReason, }))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }